module.exports = __webpack_public_path__ + "img/E-WEB-Goal-13.0b900464.svg";